import { useState } from 'react';
import Button from '../components/Button';
import { addService, updateService, deleteService } from '../firebase/services';

function Services({ services, setServices }) {
    const [isEditing, setIsEditing] = useState(null);
    const [formData, setFormData] = useState({ title: '', description: '', price: '' });

    const handleAdd = async () => {
        try {
            if (isEditing === "new") {
                const newService = await addService(formData);
                setServices([...services, newService]);
            } else if (isEditing !== null) {
                const updatedService = await updateService(services[isEditing].id, formData);
                const updatedServices = [...services];
                updatedServices[isEditing] = updatedService;
                setServices(updatedServices);
            }
            setFormData({ title: '', description: '', price: '' });
            setIsEditing(null);
        } catch (error) {
            console.error("Error saving service:", error);
        }
    };

    const handleDelete = async (index) => {
        try {
            await deleteService(services[index].id);
            const newServices = services.filter((_, i) => i !== index);
            setServices(newServices);
        } catch (error) {
            console.error("Error deleting service:", error);
        }
    };

    const handleEdit = (service, index) => {
        setIsEditing(index);
        setFormData(service);
    };

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text-3xl font-bold text-white">Manage Services</h1>
                <Button onClick={() => setIsEditing('new')}>Add New Service</Button>
            </div>

            {/* Form */}
            {isEditing !== null && (
                <div className="bg-gray-900 p-6 rounded-lg space-y-4">
                    <input
                        type="text"
                        placeholder="Title"
                        className="w-full p-2 rounded bg-gray-800 text-white"
                        value={formData.title}
                        onChange={e => setFormData({ ...formData, title: e.target.value })}
                    />
                    <textarea
                        placeholder="Description"
                        className="w-full p-2 rounded bg-gray-800 text-white"
                        value={formData.description}
                        onChange={e => setFormData({ ...formData, description: e.target.value })}
                    />
                    <input
                        type="text"
                        placeholder="Price"
                        className="w-full p-2 rounded bg-gray-800 text-white"
                        value={formData.price}
                        onChange={e => setFormData({ ...formData, price: e.target.value })}
                    />
                    <div className="flex space-x-4">
                        <Button onClick={handleAdd}>Save</Button>
                        <Button variant="secondary" onClick={() => setIsEditing(null)}>Cancel</Button>
                    </div>
                </div>
            )}

            {/* Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {services.map((service, index) => (
                    <div key={index} className="bg-gray-900 p-6 rounded-lg space-y-4">
                        <h3 className="text-xl font-bold text-white">{service.title}</h3>
                        <p className="text-gray-300">{service.description}</p>
                        <p className="text-white font-bold">${service.price}</p>
                        <div className="flex space-x-4">
                            <Button variant="secondary" onClick={() => handleEdit(service, index)}>
                                Edit
                            </Button>
                            <Button variant="danger" onClick={() => handleDelete(index)}>
                                Delete
                            </Button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Services;